import { Text } from '@taxdown/piccolo-web';
import * as Styled from './styles';
import { SummaryCardBodyProps } from './types';

const SummaryCardBody = ({ yayoyakis }: SummaryCardBodyProps): JSX.Element => (
  <Styled.SummaryCardBody>
    {yayoyakis?.map(yayoyaki => {
      const label = yayoyaki.getLabelCard();
      const value = yayoyaki.getRenderValue();
      if (yayoyaki.isDefaultValue() || value === undefined) {
        return null;
      }
      return (
        <Styled.SummaryInfo key={yayoyaki.getId()}>
          {yayoyaki.getLabelCard() && (
            <Text type="paragraphs" color="grey" size="S_S_M" mr="dimension_10">
              {`${label}:`}
            </Text>
          )}
          <Text type="paragraphs" color="dark" size="S_S_M">
            {value}
          </Text>
        </Styled.SummaryInfo>
      );
    })}
  </Styled.SummaryCardBody>
);

export default SummaryCardBody;
